var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile)?_c('div',[(!_vm.isMobile)?_c('x-dialog',{attrs:{"show":_vm.show,"maxwidth":"480","scrollable":""}},[_c('x-card',[_c('x-card-text')],1)],1):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }